import { gql, useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import LoadingScreen from '../../../common/LoadingScreen';
import useMedia from '../../../hooks/useMedia';
import SectionHeader from '../common/sectionHeader/SectionHeader';
import Breadcrumb from './Breadcrumb';
import Search from './search';

const ProductFabricsWrapper = styled.div`
  margin-bottom: 150px;
  min-height: 800px;

  .products-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }

  .filter-categories {
    margin-top: 10px;
  }
  .text-wrapper.one-column {
    max-width: 800px;
  }
  @media (max-width: 768px) {
    .products-container {
      grid-template-columns: 1fr 1fr;
    }
  }
`;

function ProductFabrics(props) {
  const match = useRouteMatch();
  const [filterOpen, setFilterOpen] = useState(false);
  const [frame, setFrame] = useState(false);
  const isMobile =
    typeof window !== `undefined` ? useMedia('(max-width: 992px) ') : null;
  const isDesktop =
    typeof window !== `undefined` ? useMedia('(min-width: 992px) ') : null;

  useEffect(() => {
    if (isDesktop) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
  }, [isDesktop]);

  const { loading, data, error } = useQuery(FRAME_BY_SLUG, {
    fetchPolicy: 'network-only',
    variables: {
      slug: match.params.frameSlug
    },
    onCompleted(data) {
      setFrame(data.frameBySlug);
    }
  });

  if (!frame || loading) return <LoadingScreen />;
  if (error) {
    return '';
  }

  let quizRedirectOnClose = match.url.split('/').join('_');

  return (
    <ProductFabricsWrapper>
      <SectionHeader
        title={`Custom Upholstered ${frame.name}`}
        description={frame.description}
        rating={frame.subcategories[0].avg_rating}
        showQuizLink={false}
      />
      <div className="container">
        <Breadcrumb />
      </div>
      <div className="container">
        <Search
          query={match.params.frameSlug}
          isMobile={isMobile}
          isDesktop={isDesktop}
          filterOpen={filterOpen}
          setFilterOpen={setFilterOpen}
        />
      </div>
    </ProductFabricsWrapper>
  );
}

export default ProductFabrics;

export const FRAME_BY_SLUG = gql`
  query frameBySlug($slug: String!) {
    frameBySlug(slug: $slug) {
      id
      slug
      name
      description
      subcategories {
        id
        name
        avg_rating
        category {
          id
          name
        }
      }
      products {
        sku
        slug
        id
        price
        name
        images {
          id
          name
          path
        }
        fabric {
          id
          is_available_on_pdp
          name
          is_kid
          colors {
            id
            name
            hex_code
          }
          pattern {
            id
            name
          }
          material {
            id
            name
            composition
          }
          collaborator {
            id
            name
          }
        }
      }
    }
  }
`;
